import smClampsTooltip from 'projectDesign/components/projectConfiguration/fieldsTooltips/smClampsTooltip';
import midClampsTooltip from 'projectDesign/components/projectConfiguration/fieldsTooltips/midClampsTooltip';
import endClampsTooltip from 'projectDesign/components/projectConfiguration/fieldsTooltips/endClampsTooltip';
import { makeAllRoofsEmpty } from '__editor/components/roofsSelector/components/roofsSelectorDrawingManager/roofsSelectorDrawingManager';
import { anyPanelsDrawn } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManagerHelper';
import nhMidClampsToolTip from '../fieldsTooltips/nhMidClampsToolTip';
import nhEndClampToolTip from '../fieldsTooltips/nhEndClampToolTip';
import { SM_TILT_MODULE_LENGTH_ORIENTATION_LIMIT } from '__common/constants/modules';
import { state } from '__common/store';
import { isNxtHorizon, isSM2Standard, isSMLT, isSMTiltPR, isSMTiltPRWithAscender } from '__common/constants/products';
import { applySMDomesticContentClampFilter } from '__common/utils/versionCompare/versionCompare';

const isClampValueMissing = (value: number | string, data: { value: number, name: string }[]) =>
  value == null || value === '' || !data.some((option) => String(option.value) === String(value));


export const apiField = 'clamps_choices';
export const midClampsApiField = 'mid_clamps_choices';
export const endClampsApiField = 'end_clamps_choices'
export const CLAMP_FIELD_TITLE = 'Are you sure you want to change the clamps specification?';
export const CLAMP_FIELD_CONTENT = 'All array layouts will be lost. Continue?';
export const smClampsOptions = {
  proClamps: {
    value: 1,
    name: 'PRO CLAMPS',
  },
  standardClamps: {
    value: 2,
    name: 'STANDARD CLAMPS',
  },
  universalClamps: {
    value : 3,
    name : 'UNIVERSAL AF',
  },
  nxtHorizonComboClamps: {
    value: 4,
    name: 'NXT UMOUNT COMBO CLAMP',
  },
  nxtHorizonHiddenEndClamps: {
    value: 5,
    name: 'NXT UMOUNT HIDDEN END CLAMP',
  },
};


const smClampsChoiceOptionsData = {
  proStdUni: [
    smClampsOptions.proClamps,
    smClampsOptions.standardClamps,
    smClampsOptions.universalClamps,
  ],
  proUni: [
    smClampsOptions.proClamps,
    smClampsOptions.universalClamps,
  ],
  nxtHorizonCombo: [
    smClampsOptions.nxtHorizonComboClamps,
  ],
  nxtHorizonComboWithHiddenEndClamp : [
    smClampsOptions.nxtHorizonComboClamps,
    smClampsOptions.nxtHorizonHiddenEndClamps,
  ],
  uni: [
    smClampsOptions.universalClamps
  ],
  stdOnly: [
    smClampsOptions.standardClamps,
  ]
}

export default {
  type: 'Select',
  label: 'clamps',
  apiField,
  tooltip: smClampsTooltip,
  title: CLAMP_FIELD_TITLE,
  content: CLAMP_FIELD_CONTENT,
  onConfirm: () => {
    makeAllRoofsEmpty();
  },
  shouldConfirm: () => anyPanelsDrawn(),
  data: smClampsChoiceOptionsData.proStdUni,
};

const getSmClampData = () => {
  const { projectConfiguration: { projectVersion, railsProductId, projectEnvConfig: { is_domestic_mlpe_required, domestic_content } } } = state();
  if (applySMDomesticContentClampFilter(projectVersion)) {
    if ((isSM2Standard(railsProductId) || isSMLT(railsProductId)) && (is_domestic_mlpe_required === 1 || domestic_content === 1)) {
      return smClampsChoiceOptionsData.stdOnly;
    }
    if (isSMTiltPR(railsProductId) && !isSMTiltPRWithAscender(railsProductId) && domestic_content === 1) {
      return smClampsChoiceOptionsData.stdOnly;
    }
  }
  return smClampsChoiceOptionsData.proStdUni;
};

export const smMidAndEndClamps = (apiField: string, label: string, isHelioscope = false, isAurora: boolean = false) => {
  const { projectConfiguration: { projectEnvConfig } } = state();
  const clampData = getSmClampData();
  return {
    type: 'Select',
    label,
    apiField,
    data: clampData,
    missing: isClampValueMissing(Number(projectEnvConfig[apiField]), clampData),
    tooltip: apiField === midClampsApiField ? midClampsTooltip : endClampsTooltip,
    title: CLAMP_FIELD_TITLE,
    content: CLAMP_FIELD_CONTENT,
    ...(!isHelioscope? {
      onConfirm: () => {
        apiField ===midClampsApiField ? makeAllRoofsEmpty() : null ;
      },
      shouldConfirm: () => apiField ===midClampsApiField ? anyPanelsDrawn() : null,
    }: {}),
    disable: isAurora,
  };
};

export const nhMidAndEndClamps = (apiField, label, isHelioscope = false, isAurora: boolean = false) => {
  const { projectConfiguration: { projectEnvConfig } } = state();
  const data = clampsData(apiField);
  return {
    type: 'Select',
    missing: isClampValueMissing(Number(projectEnvConfig[apiField]), data),
    label,
    apiField,
    tooltip: apiField === midClampsApiField ? nhMidClampsToolTip : nhEndClampToolTip,
    title: CLAMP_FIELD_TITLE,
    content: CLAMP_FIELD_CONTENT,
    ...(!isHelioscope ? {
      onConfirm: () => {
        apiField ===midClampsApiField ? makeAllRoofsEmpty() : null ;
      },
      shouldConfirm: () => apiField ===midClampsApiField ? anyPanelsDrawn() : null,
    } : {}),
    data,
    disable: isAurora
  };
};

export const clampsData = (apiField) => {
  const { projectConfiguration: { railsProductId, productId } } = state();
  if(apiField === midClampsApiField) {
    return smClampsChoiceOptionsData.nxtHorizonCombo;
  }
  else {
    if(isNxtHorizon(productId) && railsProductId == 27) {
      return smClampsChoiceOptionsData.nxtHorizonCombo;
    }
    else {
      return smClampsChoiceOptionsData.nxtHorizonComboWithHiddenEndClamp;
    }
  }
}


export const smTiltClamps = (moduleLength) => {
  const { projectConfiguration: { projectVersion, projectEnvConfig: { domestic_content } } } = state();
  return {
    type: 'Select',
    label: 'clamps',
    apiField,
    tooltip: smClampsTooltip,
    title: CLAMP_FIELD_TITLE,
    content: CLAMP_FIELD_CONTENT,
    onConfirm: () => {
      makeAllRoofsEmpty();
    },
    shouldConfirm: () => anyPanelsDrawn(),
    data: (applySMDomesticContentClampFilter(projectVersion) && domestic_content === 1) ? smClampsChoiceOptionsData.stdOnly : (moduleLength <= SM_TILT_MODULE_LENGTH_ORIENTATION_LIMIT ? smClampsChoiceOptionsData.proStdUni : smClampsChoiceOptionsData.proUni),
  };
};


  export const ascenderMidAndEndClamps = (apiField) => {
    const { projectConfiguration: { projectEnvConfig } } = state();
    return apiField === midClampsApiField? 
       {
        type: 'Select',
        label: "mid_clamps",
        apiField,
        missing: isClampValueMissing(Number(projectEnvConfig[apiField]), smClampsChoiceOptionsData.uni),
        tooltip: midClampsTooltip,
        title: CLAMP_FIELD_TITLE,
        content: CLAMP_FIELD_CONTENT,
        onConfirm: () => {
          makeAllRoofsEmpty();
        },
        shouldConfirm: () => anyPanelsDrawn(),
        data: smClampsChoiceOptionsData.uni,
      }
    : 
    {
        type: 'Select',
        label: "end_clamps",
        apiField,
        missing: isClampValueMissing(Number(projectEnvConfig[apiField]), smClampsChoiceOptionsData.proUni),
        tooltip: endClampsTooltip,
        title: CLAMP_FIELD_TITLE,
        content: CLAMP_FIELD_CONTENT,
        data: smClampsChoiceOptionsData.proUni,
      };
};
    
